export const mediaImageUploader = {
    mediaWrapper: {
      paddingBottom: "100%",
      display: "block",
      position: "relative",
    },
    media: {
      position: "absolute",
      left: 0,
      top: 0,
      height: "100%", //auto
      background: "#fff",
      borderRadius: "50%",
      border: "1px solid #E7E7E7",
      filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.05))",
      cursor: "pointer",
    },

    overlay: {
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      right: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.6)",
      borderRadius: "50%",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
    },
  } as const;